import {AbstractFormConfig} from "../abstract-form.config";

export class FormTypeaheadConfig extends AbstractFormConfig {

  public background: 'transparent' | undefined;
  public placeholder: string | undefined;
  public fixedWidthRem: number | undefined;
  public showTooltip: boolean = false;

  constructor(init?: Partial<FormTypeaheadConfig> | undefined) {
    super(init);
    Object.assign(this, init);
  }
}
